<template>
  <b-navbar class="languages-nav" v-if="availableLanguages.length > 0">
    <b-navbar-nav>
      <b-nav-item
        class="language-items"
        :class="{ active: isSelected(index) }"
        v-for="(language, index) in availableLanguages"
        :key="`language_${index}`"
        :active="isSelected(index)"
        @click="selectLanguage(index)"
      >
        <img
          :src="`/icons/languages/${language}.svg`"
          class="language-icon ml-2 mr-2"
        />
        <span :class="{ bold: isSelected(index) }">
          {{ getIdiom(language) }}
        </span>
      </b-nav-item>
    </b-navbar-nav>
  </b-navbar>
</template>

<script>
const props = {
  selectedLanguage: {
    type: Number,
    default: 0,
  },
  languages: {
    type: Array,
  },
  availableLanguages: {
    type: Array,
  },
}

export default {
  props,
  methods: {
    isSelected(language) {
      return this.selectedLanguage === language
    },
    getIdiom(language) {
      return this.languages.find(l => l.code === language).idiom
    },
    selectLanguage(index) {
      this.$emit('selectLanguage', index)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/custom/variables';
@import '~@/styles/custom/colors';

.languages-nav {
  box-shadow: 0px 5px 3px rgba(61, 90, 254, 0.1);
  border: 1px solid var(--gray07) !important;
  border-radius: 10px !important;
  padding: 0px;

  .language-items {
    height: 50px;
    width: 150px;
    display: flex;
    align-items: center;
    border-right: 1px solid map-get($theme-colors, 'gray07');

    &:last-child {
      border-right: unset;
    }

    &.active {
      border-bottom: 5px solid map-get($theme-colors, 'secondary');
    }

    &.active:first-child {
      border-bottom-left-radius: 10px;
    }

    .language-icon {
      width: 26px;
      height: 26px;
    }
  }
}
</style>
